//frontend/src/core/domain/string.js

// Pure string utilities. No React, no styles, no I/O.

export const parseCommaSeparated = (str) =>
  String(str || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

export const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : '';